export default __webpack_public_path__ + "2f6f586f9adb9f71a54c6e66f5397449.png";